// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"components-base-ErrorMessage-ErrorMessage__errorMessage--3lSvE"};